export const ADA_COMPLIANT_GRAY = "#4D5056";
export const ADA_COMPLIANT_DARK_GRAY = "#54575F";
export const ADA_COMPLIANT_RED = "#B30000";
